export const Props = () => ({
  //Тип кнопки
  type: {
    type: String,
    default: 'left',
    validator: (value) => ['left', 'right'].includes(value),
  },
});